import styled from 'styled-components';

export const LogoRueda = styled.img`
    width: 100%;


    

`

export const ContentNavegacionUsuario = styled.div`
    width: 20%;

`

export const BotonCerrarSesion = styled.button`
    background-color: var(--Color-Blanco);
    border: 1px solid var(--Color-Blanco);
    width: 100%;
    padding: .5rem 1rem;
    text-align: center;
    border-radius: 15px;
    font-family: var(--Font-DMSans-Regular);
    font-size: 14px;
    transition: all .25s linear;

    &:hover{
        border: 1px solid var(--Color-Red-Primary);
    }

    @media (max-width: 480px) {
        width: 40%;
        margin-left: 6%;
    }

`

